import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Authentication from './Authentication'; // Import your Authentication component
import Callback from './Callback'; // Import your Callback component
import InvoiceDashboard from './InvoiceDashboard';
import UserPreference from './UserPreference';
import Authenticated from './authenticated';
import InvoiceRenderer from './components/InvoiceRenderer';
import DoctorReceiptsDashboard from './DoctorReceiptstDashboard';
import CreditApplicator from './components/CreditApplicator';

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="/authentication" element={<Authentication/>} />
          <Route path="/callback" element={<Callback/>} />
          <Route path="/invoices" element={<InvoiceDashboard/>} /> 
          <Route path="/user-preference" element={<UserPreference/>} />
          <Route path="/authenticated" element={<Authenticated/>} />
          <Route path="/Invoice/:invoiceId" element={<InvoiceRenderer/>} />
          <Route path="/doctor-reports" element={<DoctorReceiptsDashboard/>} />
            <Route path="/apply-credits" element={<CreditApplicator/>} />
        </Routes>

    </BrowserRouter>
  );
}

export default App;
